import type { ProductCard as ProductCardType } from "@/lib/centra/formatters";
import { useQuery } from "@tanstack/react-query";
import styles from "./index.module.css";

import { rpc } from "#rpc";
import { CartCarousel } from "@/components/ui/Carousel";
import ProductCard from "@/features/product/components/ProductCard";
import SkeletonPC from "@/features/product/components/ProductCard/SkeletonPC";
import { useCart } from "@/lib/centra/hooks";
import { useToken } from "@frend-digital/centra/client";
import clsx from "clsx";
import { Suspense } from "react";

export const UpsellCardList = ({
  cards,
}: React.ComponentProps<"div"> & {
  cards: ProductCardType[];
}) => {
  const cardsLength = cards.length;
  const cardListWrapper = clsx({
    [styles.cards_1]: cardsLength === 1,
    [styles.cards_2]: cardsLength === 2,
    [styles.cards_3]: cardsLength === 3,
  });
  return (
    <div data-layout="page" className={cardListWrapper}>
      {cards.map((card, key) => (
        <ProductCard key={card?.id || key} product={card} related />
      ))}
    </div>
  );
};

const CartUpsell = () => {
  const token = useToken();
  const { data: cartData } = useCart();

  const productIds = cartData?.items?.map((item) => item?.item as string) || [];
  [];

  const { data: products, isLoading } = useQuery({
    queryKey: ["depict-popular", productIds],
    queryFn: async () => {
      const products = await rpc.depict.recommendations({
        product_ids: productIds,
        type: "after_basket",
        limit: 4,
        token: token!,
      });

      return products;
    },
    enabled: !!productIds.length && !!token,
  });

  if (!isLoading && (!products || products.length === 0)) return null;

  return (
    <div className={styles.container}>
      <Suspense>
        <UnsuspendedCartUpsell products={products} isLoading={isLoading} />
      </Suspense>
    </div>
  );
};

const UnsuspendedCartUpsell = ({
  products,
  isLoading,
}: {
  products?: (ProductCardType | undefined)[] | null;
  isLoading: boolean;
}) => {
  return (
    <>
      <CartCarousel
        showControls
        title="You might also like"
        className={styles.carousel}
        style={{ "--slide-width": "30%" } as React.CSSProperties}
      >
        {isLoading
          ? Array.from({ length: 8 }).map((_, index) => (
              <SkeletonPC key={index} />
            ))
          : products?.map((product) => {
              return (
                <ProductCard
                  related
                  key={product?.displayItemId}
                  product={product!}
                />
              );
            })}
      </CartCarousel>
    </>
  );
};

export default CartUpsell;
